import _defineProperty from "@babel/runtime-corejs2/helpers/defineProperty";
import { createAction, createReducer } from 'redux-act';
export var setLocale = createAction('Set locale');
export var reducer = createReducer(_defineProperty({}, setLocale.getType(), function (state, payload) {
  return payload;
}), null);
export var localeSelector = function localeSelector(state) {
  return state.locale;
};
export default reducer;